import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import HospitalBranding from './HospitalBranding';
import HomeFooter from './HomeFooter';
import HospitalServicesList from './HospitalServicesList';
import InvoiceDetails from './InvoiceDetails';
import InvoiceForm from './InvoiceForm';
import PageShell from './PageShell';
import PreviousAppointments from './PreviousAppointments';

const ServicesScreen = ({
    amount,
    closeInvoiceForm,
    closeServices,
    customerCardNumber,
    customerName,
    dependentCoupons,
    fetchInvoiceByConsultationId,
    formData,
    formatDate,
    handleDownload,
    handleInvoiceSubmit,
    hospitalImage,
    hospitalLogo,
    hospitalName,
    hospitalServices,
    invoiceForm,
    invoiceMap,
    isSubmittingInvoice,
    logo,
    memberCoupons,
    memberId,
    openForm,
    openInvoiceForm,
    previousAppointments,
    selectedInvoice,
    selectedMemberType,
    servicesLoading,
    showInvoiceForm,
    updateInvoiceForm,
    windowSize,
}) => (
    <PageShell windowSize={windowSize} alignContent="start" contentClassName="p-2 py-3 p-sm-3 pb-5">
        <div style={{ position: 'sticky', top: '15px', display: 'flex', justifyContent: 'flex-start', width: '100%', zIndex: 1 }}>
            <button
                type="button"
                aria-label="Back to family members"
                style={{
                    backgroundColor: '#0E94C3', color: '#fff', border: 'none', borderRadius: '50%', width: '40px', height: '40px',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', cursor: 'pointer', zIndex: 1000,
                }}
                onClick={closeServices}
            >
                <FontAwesomeIcon icon={faArrowLeft} />
            </button>
        </div>
        <HospitalBranding hospitalName={hospitalName} hospitalLogo={hospitalLogo} hospitalImage={hospitalImage} />
        <HospitalServicesList
            amount={amount}
            dependentCoupons={dependentCoupons}
            formData={formData}
            hospitalServices={hospitalServices}
            memberCoupons={memberCoupons}
            memberId={memberId}
            onOpenForm={openForm}
            selectedMemberType={selectedMemberType}
            servicesLoading={servicesLoading}
        />
        <PreviousAppointments
            appointments={previousAppointments}
            formatDate={formatDate}
            invoiceMap={invoiceMap}
            onGenerateInvoice={openInvoiceForm}
            onViewInvoice={fetchInvoiceByConsultationId}
        />
        <InvoiceDetails
            customerCardNumber={customerCardNumber}
            customerName={customerName}
            formatDate={formatDate}
            hospitalName={hospitalName}
            invoice={selectedInvoice}
            onDownload={handleDownload}
        />
        <InvoiceForm
            invoiceForm={invoiceForm}
            isSubmittingInvoice={isSubmittingInvoice}
            onCancel={closeInvoiceForm}
            onChange={updateInvoiceForm}
            onSubmit={handleInvoiceSubmit}
            show={showInvoiceForm}
        />
        <HomeFooter logo={logo} />
    </PageShell>
);

export default ServicesScreen;
